import { FC } from 'react';

import { MeasureConnected, MeasureConnectedProps } from '@grow-therapy-team/seedling-components';

import { PageComponentProps } from '..';
import { MeasureSchemaAndAnswers } from './types';

export function MeasuresContent({
  page,
  children,
  measureComponent: MeasureComponent = MeasureConnected,
}: PageComponentProps<MeasureSchemaAndAnswers> & {
  children?: React.ReactNode;
  measureComponent?: FC<MeasureConnectedProps>;
}) {
  if (!page.schema) return;

  return (
    <div className='flex flex-col gap-y-3'>
      <MeasureComponent
        schema={page.schema}
        initialValues={page.answers}
        provider={page.schema.isProviderSpecific ? page.provider : undefined}
        compactHeader
      />
      {children}
    </div>
  );
}
